export const SALES_TYPES = {
  BAR_TABS: "BAR_TABS",
  BOTTLE_SALES: "BOTTLE_SALES",
};
